module.exports = __webpack_public_path__ + "static/vid3-9aa6f9f2c10bed6e23260ecb108be8df.mp4";